import PropTypes from 'prop-types';
import {useMemo} from 'react';
import {
  payByPointsJsonSchema,
  payByPointsUiSchema
} from '@/services/schema/activity';
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper';
import {useAppSelector} from '@/store';
import {getCurrencySymbol, getCurrencySymbolWithName} from '@/utils/commons';

const PayByPointsSetUp = ({
  countryCode: countryCodeProp,
  formData,
  handleFormChange,
  localCurrencyCode
}) => {
  const countryCodeFromStore = useAppSelector(
    (state) => state.countryCode?.countryCode
  );

  const resolvedCountryCode = countryCodeProp ?? countryCodeFromStore ?? '';
  const pointsToRedeem = formData?.pointsToRedeem;
  const localCurrencyValue = formData?.localCurrencyValue;
  const pointsToRedeemValid = formData?.pointsToRedeemValid;
  const localCurrencyValueValid = formData?.localCurrencyValueValid;
  const pointsToRedeemNum = Number(pointsToRedeem);
  const localCurrencyValueNum = Number(localCurrencyValue);

  const currencyFromMap = getCurrencySymbol(resolvedCountryCode);
  const currencyNameFromMap = getCurrencySymbolWithName(resolvedCountryCode);
  const displayCurrency =
    (resolvedCountryCode && currencyFromMap !== '$'
      ? currencyFromMap
      : localCurrencyCode) ??
    currencyFromMap ??
    '';
  const displayCurrencyForPreview =
    localCurrencyCode ??
    (resolvedCountryCode && currencyNameFromMap !== '$'
      ? currencyNameFromMap
      : '') ??
    '';

  const showPreview = useMemo(
    () =>
      pointsToRedeemValid !== true &&
      localCurrencyValueValid !== true &&
      pointsToRedeemNum > 0 &&
      localCurrencyValueNum > 0,
    [
      pointsToRedeemValid,
      localCurrencyValueValid,
      pointsToRedeemNum,
      localCurrencyValueNum
    ]
  );

  const renderPreview = () => {
    if (!showPreview) return null;

    return (
      <section className='preview-point-pay-by-points float-right'>
        <div className='title'>PREVIEW</div>
        <div>
          <div className='preview-value'>
            Redeem <span className='font-bold'>{pointsToRedeem}</span> Points to
            get <span className='font-bold'>{localCurrencyValue}</span>{' '}
            {displayCurrencyForPreview} discount
          </div>
        </div>
      </section>
    );
  };

  return (
    <div className='flex w-full flex-wrap items-start gap-4 lg:gap-6'>
      <div className='flex flex-wrap gap-4 lg:gap-6'>
        <JsonFormsWrapper
          jsonschema={payByPointsJsonSchema}
          uischema={payByPointsUiSchema(formData, displayCurrency)}
          data={formData}
          onChange={handleFormChange}
        />
      </div>
      {renderPreview()}
    </div>
  );
};

PayByPointsSetUp.propTypes = {
  countryCode: PropTypes.string,
  formData: PropTypes.object.isRequired,
  handleFormChange: PropTypes.func.isRequired,
  localCurrencyCode: PropTypes.string
};

export default PayByPointsSetUp;
